(function () {

    angular
        .module('smartertoolsApp')
        .controller('userAccessController', ['$q', '$scope', '$log', '$timeout', 'userAccessService', 'userPartnerService', 'cacheControl', '$window', '$state', 'authenticationService', '$rootScope', userAccessController]);

    function userAccessController($q, $scope, $log, $timeout, userAccessService, userPartnerService, cacheControl, $window, $state, authenticationService, $rootScope) {
        const vm = this;
        vm.isLoading = 0;
        vm.isLoggedIn = authenticationService.isLoggedIn;
        vm.email = authenticationService.getLoggedInEmail();
        vm.areaPermissions = {};
        vm.notifications = {};
        vm.partnerInfo = null;
        vm.canAssignResellerLicenses = false;
        vm.canStartLeases = false;
        vm.hasAcceptedAgreement = false;
        vm.monogram = vm.email && vm.email.charAt(0).toUpperCase();

        // Functions
        vm.clearCacheAndReloadPage = clearCacheAndReloadPage;
        vm.showLoginOverlay = showLoginOverlay;
        vm.calculatePartnershipVars = calculatePartnershipVars;
        vm.refresh = refresh;
        vm.gotoUpgradeLicensePage = gotoUpgradeLicensePage;
        vm.gotoRenewLicensePage = gotoRenewLicensePage;
        activate();

        // -----------------------------------------------

        function activate() {
            vm.$state = $state;
            refresh();
            $rootScope.$on('userAccessService:changed', function (event, data) {
                refresh();
            });
        }

        // TODO: Hook to global login/logout signals and update all
        // TODO: isLoggedIn need to be updated when it changes

        function clearCacheAndReloadPage() {
            cacheControl.clearAllCaches();
            $window.location.reload();
        }

        function gotoUpgradeLicensePage() {
            if (authenticationService.isLoggedIn())
                location.href = '/purchase/#/modify-license';
            else
                ShowLoginOverlay(function () {
                    location.href = '/purchase/#/modify-license';
                });
        }

        function gotoRenewLicensePage() {
            if (authenticationService.isLoggedIn())
                location.href = '/purchase/#/renew-license';
            else
                ShowLoginOverlay(function () {
                    location.href = '/purchase/#/renew-license';
                });
        }

        function showLoginOverlay() {
            ShowLoginOverlay(function () {
            });
        }

        function calculatePartnershipVars() {
            const pi = vm.partnerInfo;

            vm.isActiveReseller = pi.Reseller && pi.Reseller.IsActive;
            vm.isInactiveReseller = pi.Reseller && !pi.Reseller.IsActive;
            vm.canAssignResellerLicenses = (vm.isActiveReseller || vm.isInactiveReseller) && vm.areaPermissions.PartnerReseller;
            vm.isSuspendedReseller = pi.Reseller && pi.Reseller.IsSuspended;

            vm.isActiveLeaseProvider = pi.LeaseProvider && pi.LeaseProvider.IsActive;
            vm.isInactiveLeaseProvider = pi.LeaseProvider && !pi.LeaseProvider.IsActive;
            vm.canStartLeases = vm.isActiveLeaseProvider && vm.areaPermissions.PartnerLeases;
            vm.isSuspendedLeaseProvider = pi.LeaseProvider && pi.LeaseProvider.IsSuspended;

            vm.isActiveHighAvailabilityPartner = pi.HighAvailabilityPartner && pi.HighAvailabilityPartner.IsActive;
            vm.isInactiveHighAvailabilityPartner = pi.HighAvailabilityPartner && !pi.HighAvailabilityPartner.IsActive;
            vm.isSuspendedHighAvailabilityPartner = pi.HighAvailabilityPartner && pi.HighAvailabilityPartner.IsSuspended;
        }

        function refresh() {
            vm.isLoading++;
            vm.email = authenticationService.getLoggedInEmail();
            vm.monogram = vm.email && vm.email.charAt(0).toUpperCase();
            vm.isLoggedIn();

            $q
                .all([
                    userAccessService.getAreaPermissions(),
                    userPartnerService.getPartnershipDetails()
                ])
                .then(function (arr) {
                    let data = arr[0];
                    vm.areaPermissions = data.Sections;
                    vm.notifications = data.Notifications;

                    data = arr[1];
                    vm.partnerInfo = data;
                    vm.calculatePartnershipVars();

                    vm.isLoading--;
                })
                .catch(function (err) {
                    if (err !== 'No Refresh Token')
                        vm.loadingError = 'There was a problem loading this information.  Please try again later.';
                    vm.isLoading--;
                });
        }
    }
})();